<template>
  <div class="weui-cell">
    <div class="weui-cell__bd">
      <textarea
        @change="$emit('change', currentValue)"
        @focus="onFocus"
        @blur="onBlur"
        class="weui-textarea"
        ref="rextarea"
        :placeholder="placeholder"
        :rows="rows"
        :disabled="disabled"
        :readonly="readonly"
        v-model="currentValue"
      />
      <div class="weui-textarea-counter" v-if="showCounter">
        {{ length }}/{{ maxLength }}
      </div>

      <div class="weui-cells__tips" style="color:#e64340;text-align:left;" v-if="!valid&&validateinfo.errormsg!=''">
       <wv-icon type="warn" v-if="!valid"/>
      <slot name="ft"/>
      {{validateinfo.errormsg}}
    </div>
  </div>
  </div>
</template>

<script>
//import { create } from '../utils'
import Vue from "vue"
export default {
  name: 'wvitextarea',

  props: {
    placeholder: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    rows: {
      type: [Number, String],
      default: 3
    },
    maxLength: {
      type: [Number, String],
      default: 100
    },
    disabled: Boolean,
    readonly: Boolean,
    required: {
      type: Boolean,
      default: false
    },
    validateInfo:{
      type:Object,
       default: () => {
        return {
           errormsg:''
        }
      }
    },
    value: {
      type: String,
      default: ''
    },
    validateMode: {
      type: Object,
      default: () => {
        return {
          onFocus: true,
          onBlur: true,
          onChange: true,
          onInput: true
        }
      }
    }
  },

  data () {
    return {
      //currentValue: this.value,
      //active: false,
      valid: true,
      currentValue: this.value,
      validateinfo:this.validateInfo
    }
  },

  computed: {
    length () {
      return this.currentValue ? this.currentValue.length : 0
    }
  },

  mounted () {
    if (this.maxLength && this.length > this.maxLength) {
      this.currentValue = this.value.slice(0, this.maxLength)
    } else {
      this.currentValue = this.value
    }
  },

  methods: {
    onFocus () {
      //this.$emit('focus')
      this.$emit('focus',this.$data)

      if (typeof this.validateMode === 'undefined' || this.validateMode.onFocus !== false) {
        this.validate()
      }
    },

    onBlur () {
      //this.$emit('blur')
      this.$emit('blur',this.$data)

      if (typeof this.validateMode === 'undefined' || this.validateMode.onBlur !== false) {
        this.validate()
      }
    },
    onChange () {
      this.$emit('change', this.$data)

      if (typeof this.validateMode === 'undefined' || this.validateMode.onChange !== false) {
        this.validate()
      }
    },
    validate () {
      if (this.required &&(this.currentValue === ''|| typeof(this.currentValue)=='undefined')) {
        this.valid = false
        return
      }

      if (this.minlength && this.currentValue.length < this.minlength) {
        this.valid = false
        return
      }

      this.valid = true
    }

  },



  watch: {
    currentValue (val) {
      this.$emit('input', val)
    },

    value (val) {
      // 有最大字数限制时对超出限制部分进行截取
      if (this.maxLength && val.length > this.maxLength) {
        val = val.slice(0, this.maxLength)
      }

      this.currentValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/packages/textarea/index.vue